import { forwardChildPipe } from '../../manager/forward-pipe.js';
import type { WirePreviewEnvironmentChildDeps } from './deps.js';

export function wireChildOutputPipes(d: WirePreviewEnvironmentChildDeps): void {
  const { proc, environmentId } = d;

  forwardChildPipe(proc.stdout, null, (chunk) => {
    d.stdoutTail.push(chunk);
    d.pushRemoteLogChunk(environmentId, 'stdout', chunk);
  });
  forwardChildPipe(proc.stderr, null, (chunk) => {
    d.stderrTail.push(chunk);
    d.pushRemoteLogChunk(environmentId, 'stderr', chunk);
  });
}
